if (!customElements.get('splide-slider')) {
  customElements.define(
    'splide-slider',
    class SplideSlider extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('.splide');
        this.splide = null;
      }
      getConfigs() {
        try {
          const configAttr = this.dataset.sliderConfig;
          return configAttr ? JSON.parse(configAttr) : null;
        } catch (error) {
          console.error('Failed to parse slider config:', error);
          return null;
        }
      }
      handleDesignMode() {
        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            const currentBlock = this.querySelector(`[data-id=${e.detail.blockId}`);
            const currentIndex = currentBlock?.dataset?.index;
            if (this.splide && currentIndex) {
              this.splide.go(Number(currentIndex));
            }
          });
        }
      }
      connectedCallback() {
        if (!Splide) return;
        const parsedConfigs = this.getConfigs();
        if (!parsedConfigs) return;
        this.splide = new Splide(this.slider, parsedConfigs);
        this.splide.mount();
        this.handleDesignMode();
      }
    }
  );
}
